import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { ReactComponent as ExcelIcon } from "../../../themes/Icons/Excel_Icon.svg";
import React, { useEffect } from "react";
import PropTypes from "prop-types";

const ExportExcelFile = ({ data, nameFile, withIcon }) => {
  const EXCEL_TYPE =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const EXCEL_EXTENSION = ".xlsx";

  useEffect(() => {
    if (data && data.length > 0) {
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const dataBlob = new Blob([excelBuffer], { type: EXCEL_TYPE });

      saveAs(dataBlob, nameFile + new Date().toDateString() + EXCEL_EXTENSION);
    }
  }, [data]);

  return <>{withIcon && <ExcelIcon></ExcelIcon>}</>;
};

ExportExcelFile.propTypes = {
  data: PropTypes.array,
  nameFile: PropTypes.string,
  withIcon: PropTypes.bool,
};

export default ExportExcelFile;
